var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZoomIntegrationIcon = function SvgZoomIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-integration-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.229c0-2.88 0-4.32.56-5.42A5.143 5.143 0 0 1 2.809.56C3.908 0 5.348 0 8.228 0h7.543c2.88 0 4.32 0 5.421.56a5.143 5.143 0 0 1 2.247 2.248c.561 1.1.561 2.54.561 5.42v7.543c0 2.88 0 4.32-.56 5.421a5.144 5.144 0 0 1-2.248 2.247c-1.1.561-2.54.561-5.42.561H8.228c-2.88 0-4.32 0-5.42-.56A5.143 5.143 0 0 1 .56 21.191C0 20.092 0 18.652 0 15.772V8.228Z",
    fill: "#4087FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.126 7C4.504 7 4 7.533 4 8.19v5.774C4 15.641 5.285 17 6.871 17l6.67-.06c.622 0 1.126-.533 1.126-1.19V9.917C14.667 8.24 13.14 7 11.556 7h-6.43ZM16.189 9.273a2.015 2.015 0 0 0-.633 1.477v2.416c0 .566.23 1.104.633 1.477l2.503 2.067c.51.473 1.308.09 1.308-.626V7.946c0-.716-.798-1.099-1.308-.627L16.19 9.273Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-integration-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-90 12 12)"
  })))));
};

export default SvgZoomIntegrationIcon;